<template>
  <div>
    <v-card
      v-if="localServiceComponentModel.id !== undefined"
      class="pa-3 mb-5 elevation-1"
      outlined
    >
      <v-card-title>
        <slot name="title">受領側サービス構成モデル</slot>
        <v-spacer></v-spacer>
        <v-chip
          label dark color="gray darken-4" class="ml-3 px-4"
          v-if="tradeContract.isOtherConsume">
          利用
        </v-chip>
        <v-chip
          label dark color="gray darken-4" class="ml-3 px-4"
          v-if="tradeContract.isOtherProduce">
          提供
        </v-chip>
      </v-card-title>
      <v-card-text>
        <v-card
          v-if="localServiceComponentModel.id !== undefined"
          class="pa-3 mt-3 elevation-1"
          outlined
        >
          <v-row dense>
            <v-col md="3" cols="8">
              <text-field-like
                label="サービス構成モデル名"
                :value="localServiceComponentModel.name"
                :value-hds-id="localServiceComponentModel.id">
              </text-field-like>
            </v-col>
            <v-col md="3" cols="8">
              <text-field-like
                label="個別辞書名"
                :value="localServiceComponentModel.dictionary ? localServiceComponentModel.dictionary.name : ''"
                :value-hds-id="localServiceComponentModel.dictionary ? localServiceComponentModel.dictionary.id : ''">
              </text-field-like>
            </v-col>
            <v-col cols="6">
              <text-field-like
                :value="localServiceComponentModel.description"
                label="説明"
                placeholder="未設定"
                hide-details
                multi-line>
              </text-field-like>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          v-else
          class="pa-3 mt-3 elevation-1"
          outlined
        >
          <v-card-text>サービス構成モデルが選択されていません</v-card-text>
        </v-card>

        <v-card
          v-if="localProcessComponentModel.id !== undefined"
          class="pa-3 mt-3 elevation-1"
          outlined
        >
          <v-row dense>
            <v-col cols="6">
              <text-field-like
                label="プロセス構成モデル名"
                :value="localProcessComponentModel.name"
                :value-hds-id="localProcessComponentModel.id">
              </text-field-like>
            </v-col>
            <v-col cols="6">
              <text-field-like
                :value="localProcessComponentModel.description"
                label="説明"
                placeholder="未設定"
                hide-details
                multi-line>
              </text-field-like>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          v-else
          class="pa-3 mt-3 elevation-1"
          outlined
        >
          <v-card-text>プロセス構成モデルが選択されていません</v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <v-alert
      v-if="localServiceComponentModel.id === undefined"
      class="mb5"
      icon="mdi-information-outline"
      outlined>
      受領側サービス構成モデルを選択していません
    </v-alert>
  </div>
</template>
<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TradeContractFormatView from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import {mapActions} from "vuex";
import gql from "graphql-tag";

export default {
  name: "CompanionServiceComponentModelInfo",
  components: {
    TextFieldLike,
  },
  props: {
    tradeContract: {
      type: TradeContractFormatView,
      required: true
    },
  },
  data() {
    return {
      localServiceComponentModel: {},
      localProcessComponentModel: {},
    };
  },
  methods: {
    ...mapActions({
      _gqlQuery: 'hds/gqlQuery',
    }),
  },
  watch: {
    tradeContract: {
      immediate: true,
      async handler(tradeContract) {
        const localServiceComponentModelId = tradeContract.otherServiceComponentModelId;
        if (localServiceComponentModelId) {
          const {localServiceComponentModel} = await this._gqlQuery({
            query: gql`
              query FindServiceComponentModel(
                  $localServiceComponentModelId: ID!
              ) {
                  localServiceComponentModel: serviceComponentModel(serviceComponentModelId: $localServiceComponentModelId) {
                      id
                      name
                      description
                      dictionary {
                          id
                          name
                          description
                      }
                  }
              }`,
            variables: {
              localServiceComponentModelId: localServiceComponentModelId,
            }
          });
          this.localServiceComponentModel = localServiceComponentModel;
        } else {
          this.localServiceComponentModel = {};
        }

        const localProcessComponentModelId = tradeContract.otherProcessComponentModelId;
        if (localProcessComponentModelId) {
          const {localProcessComponentModel} = await this._gqlQuery({
            query: gql`
              query FindServiceComponentModel(
                  $localProcessComponentModelId: ID!
              ) {
                  localProcessComponentModel: processComponentModel(processComponentModelId: $localProcessComponentModelId) {
                      id
                      name
                      description
                  }
              }`,
            variables: {
              localProcessComponentModelId: localProcessComponentModelId,
            }
          });
          this.localProcessComponentModel = localProcessComponentModel;
        } else {
          this.localProcessComponentModel = {};
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.v-alert {
  border-color: rgba(0,0,0,0.12) !important;

  ::v-deep .v-alert__content {
    text-align: left;
  }
}

</style>
